import React, { useState } from "react";
import { Box, Fab, Button, Zoom } from "@mui/material";
import {
  Add,
  Close,
  Task,
  Description,
  CreditCard,
  DirectionsCar,
} from "@mui/icons-material";
import AddTaskForm from "../AddTaskForm/AddTaskForm";
import FileAClaim from "../../components/FileAClaim/FileAClaim";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { RootState } from "../../store/store";
import Payment from "../../customers/Payment/Payment";
import CustomDrawer from "../../common/CustomDrawer/CustomDrawer";
import { FloaterButton } from "./AgentFloaterButtonStyles";

// Define Action type
interface Action {
  icon: JSX.Element;
  label: string;
  color: string;
  onClick: () => void;
}

const AgentFloaterButton: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [drawerContent, setDrawerContent] = useState<string>("");
  const { policyDetailsHeader } = useAppSelector(
    (store: RootState) => store.policyDetails
  );

  let dueAmount = "0.00";
  let carrierPolicyNumber = "No Policy";
  if (policyDetailsHeader && policyDetailsHeader.dueAmount) {
    dueAmount = policyDetailsHeader.dueAmount;
  }
  if (policyDetailsHeader && policyDetailsHeader.carrierPolicyNumber) {
    carrierPolicyNumber = policyDetailsHeader.carrierPolicyNumber;
  }
  const params = useParams();
  const fullPath = params["*"];

  const pathSegments = fullPath ? fullPath.split("/") : [];

  const policyId = pathSegments[1] || "";
  const carrier = pathSegments[2] || "";
  const system = pathSegments[3] || "";
  const lobCode = pathSegments[4] || "";

  // Toggle FAB Menu
  const toggleMenu = (): void => {
    setOpen((prev) => !prev);
  };

  // Open Drawer with specific content
  const openDrawer = (content: string): void => {
    setDrawerContent(content);
    setDrawerOpen(true);
  };

  const actions: Action[] = [
    {
      icon: <Task />,
      label: "Add Task",
      color: "#11a8a5",
      onClick: () => openDrawer("Add Task"),
    },
    // {
    //   icon: <Description />,
    //   label: "FNOL",
    //   color: "#f79432",
    //   onClick: () => openDrawer("FNOL"),
    // },
    {
      icon: <CreditCard />,
      label: "Pay",
      color: "#4fbbeb",
      onClick: () => openDrawer("Pay"),
    },
    // {
    //   icon: <DirectionsCar />,
    //   label: "Roadside Assistance",
    //   color: "#24247c",
    //   onClick: () => openDrawer("Roadside Assistance"),
    // },
  ];

  return (
    <>
      <Box 
        id="floater-button-container"
        data-test-id="test-floater-button-container"
        aria-label="Floater button container"
        sx={FloaterButton.container}
      >
        <Box
          id="floater-actions-container"
          data-test-id="test-floater-actions-container"
          aria-label="Floater actions container"
          sx={{
            ...FloaterButton.actionButtonContainer,
            display: open ? "flex" : "none",
          }}
        >
          {actions.map((action, index) => (
            <Zoom in={open} key={index}>
              <Button
                id={`floater-action-${action.label.toLowerCase().replace(/\s+/g, '-')}`}
                data-test-id={`test-floater-action-${action.label.toLowerCase().replace(/\s+/g, '-')}`}
                aria-label={`${action.label} action button`}
                variant="contained"
                startIcon={action.icon}
                sx={FloaterButton.actionButton(action.color)}
                onClick={action.onClick}
              >
                {action.label}
              </Button>
            </Zoom>
          ))}
        </Box>

        <Fab 
          id="floater-toggle-button"
          data-test-id="test-floater-toggle-button"
          aria-label={open ? "Close floater menu" : "Open floater menu"}
          color="primary" 
          onClick={toggleMenu} 
          sx={FloaterButton.fab}
        >
          {open ? <Close /> : <Add />}
        </Fab>
      </Box>

      {drawerOpen && drawerContent === "Add Task" && (
        <AddTaskForm
          open={drawerOpen}
          handleClose={() => setDrawerOpen(false)}
        />
      )}

      {drawerOpen && drawerContent === "FNOL" && (
        <FileAClaim
          open={drawerOpen}
          setOpen={setDrawerOpen}
          policyId={policyId || ""}
          lobCode={lobCode || "pa"}
          carrier={carrier || ""}
          system={system || ""}
        />
      )}

      {drawerOpen && drawerContent === "Pay" && (
        <CustomDrawer
          content={
            // <Box sx={FloaterButton.paymentCardStyle}>
            <Payment
              amount={dueAmount}
              carrierPolicyNumber={carrierPolicyNumber}
            />
            // </Box>
          }
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          title={`${"Payment for Policy Number"} : ${carrierPolicyNumber}`}
        />
      )}
    </>
  );
};

export default AgentFloaterButton;
